export default __webpack_public_path__ + "static/media/keval.560973eb.jpeg";